import { render, staticRenderFns } from "./Untitled2.vue?vue&type=template&id=e2009d7a&scoped=true&"
import script from "./Untitled2.vue?vue&type=script&lang=js&"
export * from "./Untitled2.vue?vue&type=script&lang=js&"
import style0 from "./Untitled2.vue?vue&type=style&index=0&id=e2009d7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2009d7a",
  null
  
)

export default component.exports